import { render, staticRenderFns } from "./priceLabelInfo.vue?vue&type=template&id=51ec82df"
import script from "./priceLabelInfo.vue?vue&type=script&lang=js"
export * from "./priceLabelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports